import React from 'react'


const WaveLoading = () => {

    return <div id="wave" className="wave-loading">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
    </div>
}

export default WaveLoading


// WEBPACK FOOTER //
// ./src/components/WaveLoading.jsx